//src/components/Sidebar.jsx

import React from "react";
import { Link } from "react-router-dom";

export default function Sidebar() {
  return (
    <div className="bg-light vh-100 p-2">
      <ul className="list-group">
        <li className="list-group-item">
          <Link to="/dashboard/users" className="text-decoration-none">Users</Link>
        </li>
        <li className="list-group-item">
          <Link to="/dashboard/ai-recordings" className="text-decoration-none">AI Recordings</Link>
        </li>
      </ul>
    </div>
  );
}